import React from 'react';
import { Box, Typography, Divider } from '@mui/material';

export default function History() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      pt={4}
      px={4}
      minWidth={300}
    >
      <Typography
        variant="h6"
        sx={{ color: '#2B1810', fontFamily: 'Courier New', mb: 1, letterSpacing: 2 }}
      >
        History
      </Typography>

      <Box
        sx={{
          minWidth: 320,
          maxWidth: 600,
          border: '1px solid #D4B896',
          borderRadius: '8px',
          p: 3,
          bgcolor: '#FBF5EC',
        }}
      >
        <Typography
          sx={{ color: '#7A5035', fontFamily: 'Courier New', fontSize: '0.75rem', letterSpacing: 2, mb: 3 }}
        >
          ACKNOWLEDGMENTS
        </Typography>

        <Box mb={3}>
          <Typography
            sx={{ color: '#2B1810', fontFamily: 'Courier New', fontWeight: 'bold', fontSize: '0.95rem' }}
          >
            Arianna Kamarnitskaya
          </Typography>
          <Typography
            sx={{ color: '#2B1810', fontFamily: 'Courier New', fontSize: '0.85rem', mt: 1 }}
          >
            For inspiring the logo by creating the first 3D version by hand. Your creativity brought Pelmeshka to visual life.
          </Typography>
        </Box>

        <Divider sx={{ my: 2, borderColor: '#D4B896' }} />

        <Box mb={3}>
          <Typography
            sx={{ color: '#2B1810', fontFamily: 'Courier New', fontWeight: 'bold', fontSize: '0.95rem' }}
          >
            Marianna Kapliuk
          </Typography>
          <Typography
            sx={{ color: '#2B1810', fontFamily: 'Courier New', fontSize: '0.85rem', mt: 1 }}
          >
            For challenging me financially and inspiring me with the name. Your entrepreneurial spirit pushed this project forward.
          </Typography>
        </Box>

        <Divider sx={{ my: 2, borderColor: '#D4B896' }} />

        <Box mb={3}>
          <Typography
            sx={{ color: '#2B1810', fontFamily: 'Courier New', fontWeight: 'bold', fontSize: '0.95rem' }}
          >
            Lauriane Miclo
          </Typography>
          <Typography
            sx={{ color: '#2B1810', fontFamily: 'Courier New', fontSize: '0.85rem', mt: 1 }}
          >
            For being my first customer. Your trust and support made this project real.
          </Typography>
        </Box>

        <Divider sx={{ my: 2, borderColor: '#D4B896' }} />

        <Box>
          <Typography
            sx={{ color: '#2B1810', fontFamily: 'Courier New', fontWeight: 'bold', fontSize: '0.95rem' }}
          >
            Mischa Molhoek
          </Typography>
          <Typography
            sx={{ color: '#2B1810', fontFamily: 'Courier New', fontSize: '0.85rem', mt: 1 }}
          >
            For teaching me how to use agents to code. This project exists because of the knowledge and guidance shared.
          </Typography>
        </Box>

        <Divider sx={{ my: 2, borderColor: '#D4B896' }} />

        <Box>
          <Typography
            sx={{ color: '#2B1810', fontFamily: 'Courier New', fontWeight: 'bold', fontSize: '0.95rem' }}
          >
            Claude
          </Typography>
          <Typography
            sx={{ color: '#2B1810', fontFamily: 'Courier New', fontSize: '0.85rem', mt: 1 }}
          >
            For coding all of this. Every line, every component, every integration brought to life through tireless implementation.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
